import { FC, memo } from 'react'
import { Modal } from 'components/layouts/modal/modal'
import { ProjectEntryForm } from 'features/project/components/projectEntryDialog/components/projectEntryForm/projectEntryForm'

type PropsMode = {
  isEditMode: boolean
  title: string
  isOpen: boolean
  onClose: () => void
  projectId?: string
  onSubmit: (projectId: string) => void
  onDeleted?: () => void
}

export type ProjectDialogProps = PropsMode

export const ProjectEntryDialog: FC<ProjectDialogProps> = memo((props) => {
  return (
    <Modal
      id="project-entry-dialog"
      title={props.title}
      isOpen={props.isOpen}
      onClose={props.onClose}
    >
      <ProjectEntryForm
        isEditMode={props.isEditMode}
        projectId={props.projectId}
        onSubmit={props.onSubmit}
        onCancel={props.onClose}
        onDeleted={props.onDeleted}
      />
    </Modal>
  )
})
